/**
 * external libs
 */
import axios from 'axios';
/**
 * internal services
 */
import detectLanguage from "../utils/detectLanguage";
import {StorageService} from "../services";
/**
 * internal services
 */
import {
	API_BASE_COR_ID_ENV_URL,
	API_AUTH_REFRESH_FINANCE_URI,
	API_AUTH_REFRESH_COR_ID_URI
} from "../constants/api.constant";
import TokenUtils from "../utils/tokenUtils";

let refreshDoing = false;

axios.interceptors.request.use(async (req) => {
	req.headers["Accept-Language"] = `${detectLanguage()};q=1`
	let accessToken = null;
	// req.headers["Content-Type"] = `application/json`

	if([API_AUTH_REFRESH_FINANCE_URI, API_AUTH_REFRESH_COR_ID_URI].includes(req.url || "")){
		if([API_AUTH_REFRESH_COR_ID_URI].includes(req.url || "")){
			req.headers.Authorization = `Bearer ${StorageService.refreshCorIdToken}`;
		}

		if(refreshDoing){
			throw new axios.Cancel("Blocked request to refresh URL");
		}

		refreshDoing = true
		return req;
	}

	await new Promise((resolve) => {
		if(!refreshDoing){
			resolve(true)
		}

		setInterval(() => {
			if(!refreshDoing){
				resolve(true)
			}
		}, 200)
	})

	refreshDoing = false
	accessToken = req.url?.startsWith(API_BASE_COR_ID_ENV_URL || "") ? await TokenUtils.getAccessCorIdToken() : await TokenUtils.getAccessToken();
	console.log("Using access token:", accessToken)
	if(accessToken){
		req.headers.Authorization = `Bearer ${accessToken}`;
	}
	return req;
});

axios.interceptors.response.use(
	(response) => {
		if([API_AUTH_REFRESH_FINANCE_URI, API_AUTH_REFRESH_COR_ID_URI].includes(response?.config?.url || "")){
			refreshDoing = false;
		}
		return response
	},
	async (error) => {
		// Log the error for debugging
		console.error('API Error:', {
			status: error.response?.status,
			statusText: error.response?.statusText,
			data: error.response?.data,
			url: error.config?.url,
			method: error.config?.method
		});

		if(error.response?.status === 401){
			TokenUtils.logout()
			return Promise.reject(error?.response || error);
		}

		return Promise.reject(error?.response || error);
	},
);
